var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"terms"}},[_c('div',[_vm._v("Terms and conditions to come here soon...")]),_c('a',{staticStyle:{"color":"#DADADA"},on:{"click":function($event){$event.preventDefault();return _vm.go_back();}}},[_vm._v("\n\t\t<< back\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }